/**
 * BranchScreen (S2) — branch pick, ONLY reached when ctx.branches.length > 1.
 * Props: { ctx, api, tg, nav, state, setState, params:{direction} } (see App.jsx).
 *
 *   - Render ctx.branches as .branch-opt rows; tap selects (haptic 'selection').
 *   - MainButton "Davom etish" → setState({branchId}) then
 *       nav.push(LOCATION, { direction, branch_id }).
 */
import { useEffect, useState } from 'react';
import Screen from '../components/Screen.jsx';
import Button from '../components/Button.jsx';
import { T } from '../lib/i18n.js';
import { SCREENS } from '../App.jsx';

export default function BranchScreen({ ctx, tg, nav, params, setState }) {
  const branches = ctx.branches || [];
  const [selected, setSelected] = useState(branches[0]?.id ?? null);

  // Branch chosen → carry it forward to LOCATION (GPS), then LIVE (in-app cam).
  function proceed() {
    if (selected == null) {
      tg.haptic('warning');
      return;
    }
    tg.haptic('selection');
    setState({ branchId: selected });
    nav.push(SCREENS.LOCATION, {
      direction: params?.direction,
      branch_id: selected,
    });
  }

  useEffect(() => {
    if (!tg.isTelegram) return undefined;
    return tg.MainButton.onClick(proceed);
  });

  useEffect(() => {
    if (!tg.isTelegram) return undefined;
    tg.MainButton.setText(T.btn_continue);
    tg.MainButton.show();
    return () => tg.MainButton.hide();
  }, [tg]);

  return (
    <Screen
      title={T.branch_prompt}
      footer={
        !tg.isTelegram ? (
          <Button onClick={proceed} disabled={selected == null}>
            {T.btn_continue}
          </Button>
        ) : null
      }
    >
      {branches.map((b) => {
        const sel = b.id === selected;
        return (
          <button
            type="button"
            className={`branch-opt ${sel ? 'sel' : ''}`}
            key={b.id}
            onClick={() => {
              tg.haptic('selection');
              setSelected(b.id);
            }}
          >
            <span className="ic">🏬</span>
            <span className="nm">{b.name}</span>
            {sel ? (
              <span className="mk" style={{ fontSize: 12, color: 'var(--accent)' }}>
                {T.branch_selected} ◉
              </span>
            ) : (
              <span className="mk">○</span>
            )}
          </button>
        );
      })}
    </Screen>
  );
}
